import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import InternationalContent from '../../components/Pages/International';

const { displayName } = config;

export default function International(): React.ReactElement {
  document.title = `${displayName}: International`;

  return (
    <Layout>
      <InternationalContent />
    </Layout>
  );
}
